import React, { useState } from 'react';
import { Box, Flex } from 'theme-ui';
import { Button, ButtonProps, InputProps } from 'antd';
import { PlusOutlined, MinusOutlined } from '@ant-design/icons';

interface Props extends Omit<InputProps, 'onChange'> {
  value?: number;
  onChange?: (value: number) => void;
}
export const StepInput: React.FC<Props> = ({ value, onChange }) => {
  const [counter, setCounter] = useState(0);

  React.useEffect(() => {
    setCounter(value || 0);
  }, [value]);

  const update = (nextValue: number) => {
    setCounter(nextValue);
    onChange && onChange(nextValue);
  }

  const increment = () => {
    update(counter + 1);
  }

  const decrement = () => {
    if (counter > 0) {
      update(counter - 1);
    }
  }

  return (
    <Flex sx={{ gap: 2, alignItems: 'center' }}>
      <CircleButton icon={<MinusOutlined />} onClick={decrement} />
      <Box sx={{width: 30, textAlign: 'center'}}>
        {counter}
      </Box>
      <CircleButton icon={<PlusOutlined />} onClick={increment} />
    </Flex>
  );
};

const CircleButton: React.FC<ButtonProps> = (props) => {
  return (
    <Button type="default" shape="circle" {...props} />
  )
}
